export const SUBSCRIPTION_TYPES = {
  EXT_SUBSCRIPTION: "ExtSubscription",
  SUBSCRIPTION_SCHEDULE: "SubscriptionSchedule",
  COMP: "Comp",
} as const;

export const SUBSCRIPTION_PRODUCT_TYPES = {
  COACH_DEFINED: "CoachDefined",
  COACH_MATCH: "CoachMatch",
  SELF_PAID_PREMIUM: "SelfPaidPremium",
} as const;

export const SUBSCRIPTION_STATUSES = {
  ACTIVE: "Active",
  PAST_DUE: "Past Due",
  CANCELLED: "Cancelled",
  SCHEDULED: "Scheduled",
  TRIALING: "Trialing",
  COMPLIMENTARY: "Complimentary",
  PAUSED: "Paused",
} as const;

export const SUBSCRIPTION_SOURCES = {
  STRIPE: "Stripe",
  ZUORA: "Zuora",
  APPLE: "Apple",
  GOOGLE: "Google",
} as const;

export const PRODUCT_DURATIONS = {
  MONTHLY: 1,
  QUARTERLY: 3,
  BI_ANNUAL: 6,
  ANNUAL: 12,
} as const;

export const RECURRING_INTERVALS = {
  WEEK: "week",
  MONTH: "month",
  YEAR: "year",
} as const;